"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "idro": {
    "54e1ab85": [{
      "hkey": "19c3523a",
      "slug": "crone-lempato",
      "name": "Crone-Lempato",
      "primary": true,
      "skipSearch": false
    }],
    "crone": [{
      "hkey": "19c3523a",
      "slug": "crone-lempato",
      "name": "Crone-Lempato",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "d2a937db": [{
      "hkey": "19c3523a",
      "slug": "crone-lempato",
      "name": "Crone-Lempato",
      "primary": true,
      "skipSearch": false
    }],
    "lemprato": [{
      "hkey": "19c3523a",
      "slug": "crone-lempato",
      "name": "Crone-Lempato",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "idro"
    }],
    "43e69b7a": [{
      "hkey": "fcc8f76c",
      "slug": "idro",
      "name": "Idro",
      "primary": true,
      "skipSearch": false
    }],
    "ponte": [{
      "hkey": "fcc8f76c",
      "slug": "idro",
      "name": "Idro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;